(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gumind-videos"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const videoPlayers = document.querySelectorAll('.video-item__play');
  const slider = document.querySelector('.video-grid');
  const container = document.querySelector('.video-grid-container');
  const items = document.querySelectorAll('.video-item');
  const navDots = document.querySelectorAll('.video-nav-dot');
  const itemWidth = items[0].offsetWidth + 16; // Ancho + gap
  
  let isDown = false;
  let startX;
  let scrollLeft;
  let isDragging = false;

  function updateActiveStates() {
    const scrollPosition = container.scrollLeft;
    const index = Math.round(scrollPosition / itemWidth) % 4;
    
    navDots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });

    items.forEach((item, i) => {
      item.classList.toggle('active', i % 4 === index);
    });
  }

  function smoothScrollTo(position) {
    container.scrollTo({
      left: position,
      behavior: 'smooth'
    });
  }

  // Navegación por dots
  navDots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      const targetScroll = index * itemWidth;
      smoothScrollTo(targetScroll);
    });
  });

  // Eventos táctiles y de mouse
  function handleDragStart(e) {
    isDown = true;
    isDragging = false;
    slider.classList.add('dragging');
    startX = e.type === 'mousedown' ? e.pageX : e.touches[0].pageX;
    scrollLeft = container.scrollLeft;
  }

  function handleDragMove(e) {
    if (!isDown) return;
    e.preventDefault();
    
    const x = e.type === 'mousemove' ? e.pageX : e.touches[0].pageX;
    const walk = (startX - x);
    
    if (Math.abs(walk) > 5) {
      isDragging = true;
    }
    
    container.scrollLeft = scrollLeft + walk;
  }

  function handleDragEnd() {
    isDown = false;
    slider.classList.remove('dragging');
    
    if (isDragging) {
      const currentScroll = container.scrollLeft;
      const targetIndex = Math.round(currentScroll / itemWidth);
      smoothScrollTo(targetIndex * itemWidth);
    }
    
    updateActiveStates();
  }

  // Mouse events
  slider.addEventListener('mousedown', handleDragStart);
  window.addEventListener('mousemove', handleDragMove);
  window.addEventListener('mouseup', () => {
    if (isDown) handleDragEnd();
  });
  slider.addEventListener('mouseleave', () => {
    if (isDown) handleDragEnd();
  });

  // Touch events
  slider.addEventListener('touchstart', handleDragStart, { passive: false });
  window.addEventListener('touchmove', handleDragMove, { passive: false });
  window.addEventListener('touchend', () => {
    if (isDown) handleDragEnd();
  });

  // Scroll event
  container.addEventListener('scroll', () => {
    if (!isDown) {
      updateActiveStates();
    }
  });

  // Reproducción de videos
  videoPlayers.forEach(player => {
    player.addEventListener('click', function(e) {
      if (isDragging) {
        e.preventDefault();
        return;
      }

      const videoUrl = this.dataset.videoUrl;
      const videoElement = this.closest('.video-item').querySelector('video');
      
      if (videoElement) {
        if (videoElement.paused) {
          videoElement.play();
          this.style.opacity = '0';
        } else {
          videoElement.pause();
          this.style.opacity = '1';
        }
      } else if (videoUrl) {
        const videoId = videoUrl.split('v=')[1];
        if (videoId) {
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.style.position = 'absolute';
          iframe.style.top = '0';
          iframe.style.left = '0';
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          
          const videoContainer = this.closest('.video-item');
          const thumbnail = videoContainer.querySelector('.video-item__thumbnail');
          if (thumbnail) thumbnail.style.display = 'none';
          this.style.display = 'none';
          videoContainer.appendChild(iframe);
        }
      }
    });
  });

  // Inicializar
  updateActiveStates();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-product"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function initializeSlider() {
    const slider = $('.reviews-slider');
    
    if (window.innerWidth <= 768) {
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }
      
      slider.on('init', function(slick) {
        setTimeout(function() {
          slider.slick('slickPlay');
        }, 100);
      });

      slider.slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: false,
        cssEase: 'ease',
        pauseOnHover: false,
        pauseOnFocus: false,
        swipe: true,
        touchMove: true,
        draggable: true,
        waitForAnimate: false,
        centerMode: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        // Asegurar que el autoplay continúe después de cada cambio
        slider.slick('slickPlay');
      });
    }
  }

  // Primera inicialización
  initializeSlider();

  // Reinicializar en cambio de tamaño con debounce
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      initializeSlider();
    }, 250);
  });

  // Forzar el autoplay cada 10 segundos por si se detiene
  setInterval(function() {
    const slider = $('.reviews-slider');
    if (slider.hasClass('slick-initialized')) {
      slider.slick('slickPlay');
    }
  }, 10000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gumind-estres"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const videoPlayers = document.querySelectorAll('.video-item__play');
  const slider = document.querySelector('.video-grid');
  const container = document.querySelector('.video-grid-container');
  const items = document.querySelectorAll('.video-item');
  const navDots = document.querySelectorAll('.video-nav-dot');
  const itemWidth = items[0].offsetWidth + 16; // Ancho + gap
  
  let isDown = false;
  let startX;
  let startY;
  let scrollLeft;
  let isDragging = false;
  let isScrollingVertically = false;

  function updateActiveStates() {
    const scrollPosition = container.scrollLeft;
    const index = Math.round(scrollPosition / itemWidth) % 4;
    
    navDots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });

    items.forEach((item, i) => {
      item.classList.toggle('active', i % 4 === index);
    });
  }

  function smoothScrollTo(position) {
    container.scrollTo({
      left: position,
      behavior: 'smooth'
    });
  }

  // Navegación por dots
  navDots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      const targetScroll = index * itemWidth;
      smoothScrollTo(targetScroll);
    });
  });

  // Eventos táctiles y de mouse
  function handleDragStart(e) {
    if (e.type === 'touchstart') {
      startX = e.touches[0].pageX;
      startY = e.touches[0].pageY;
    } else {
      startX = e.pageX;
      startY = e.pageY;
    }
    
    isDown = true;
    isDragging = false;
    isScrollingVertically = false;
    slider.classList.add('dragging');
    scrollLeft = container.scrollLeft;
  }

  function handleDragMove(e) {
    if (!isDown) return;
    
    const x = e.type === 'mousemove' ? e.pageX : e.touches[0].pageX;
    const y = e.type === 'mousemove' ? e.pageY : e.touches[0].pageY;
    const deltaX = Math.abs(x - startX);
    const deltaY = Math.abs(y - startY);

    // Determinar la dirección del scroll en el primer movimiento
    if (!isDragging && !isScrollingVertically) {
      if (deltaX > deltaY && deltaX > 5) {
        isDragging = true;
        e.preventDefault();
      } else if (deltaY > deltaX && deltaY > 5) {
        isScrollingVertically = true;
        return;
      }
    }

    // Si estamos scrolleando verticalmente, permitir el comportamiento normal
    if (isScrollingVertically) return;

    // Si estamos arrastrando horizontalmente, prevenir el scroll vertical
    if (isDragging) {
      e.preventDefault();
      const walk = startX - x;
      container.scrollLeft = scrollLeft + walk;
    }
  }

  function handleDragEnd() {
    if (!isDown) return;
    
    isDown = false;
    slider.classList.remove('dragging');
    
    if (isDragging) {
      const currentScroll = container.scrollLeft;
      const targetIndex = Math.round(currentScroll / itemWidth);
      smoothScrollTo(targetIndex * itemWidth);
    }
    
    updateActiveStates();
    isDragging = false;
    isScrollingVertically = false;
  }

  // Mouse events
  slider.addEventListener('mousedown', handleDragStart);
  window.addEventListener('mousemove', handleDragMove);
  window.addEventListener('mouseup', handleDragEnd);
  slider.addEventListener('mouseleave', handleDragEnd);

  // Touch events
  slider.addEventListener('touchstart', handleDragStart, { passive: true });
  window.addEventListener('touchmove', handleDragMove, { passive: false });
  window.addEventListener('touchend', handleDragEnd);

  // Scroll event
  container.addEventListener('scroll', () => {
    if (!isDown) {
      updateActiveStates();
    }
  });

  // Reproducción de videos
  videoPlayers.forEach(player => {
    player.addEventListener('click', function(e) {
      if (isDragging) {
        e.preventDefault();
        return;
      }

      const videoUrl = this.dataset.videoUrl;
      const videoElement = this.closest('.video-item').querySelector('video');
      
      if (videoElement) {
        if (videoElement.paused) {
          videoElement.play();
          this.style.opacity = '0';
        } else {
          videoElement.pause();
          this.style.opacity = '1';
        }
      } else if (videoUrl) {
        const videoId = videoUrl.split('v=')[1];
        if (videoId) {
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.style.position = 'absolute';
          iframe.style.top = '0';
          iframe.style.left = '0';
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          
          const videoContainer = this.closest('.video-item');
          const thumbnail = videoContainer.querySelector('.video-item__thumbnail');
          if (thumbnail) thumbnail.style.display = 'none';
          this.style.display = 'none';
          videoContainer.appendChild(iframe);
        }
      }
    });
  });

  // Inicializar
  updateActiveStates();
});

  } catch(e) { console.error(e); }
})();
})();
